// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { IAddEntityModalParameters } from '../models/AddEntityModalParameters';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../styles/ButtonTextStyle';
import '../../../../../Content/css/theme/kanban.css';
interface CheckPermissionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const NoPermissionDialog: React.FC<CheckPermissionDialogProps> = ({ isOpen, onClose, message }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            maxWidth: '492px',
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 1,
        }}
      >
        Permission Denied
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>{message}</DialogContent>
      <ThemeProvider theme={theme}>
        <DialogActions>
          <Button variant="contained" color="info" onClick={onClose}>
            OK
          </Button>
        </DialogActions>
      </ThemeProvider>
    </Dialog>
  );
};

export default NoPermissionDialog;
